import type {PlayerRef} from '@remotion/player';
import {useCallback, useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import { PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useGlobalContext } from '@src/context/globalContext';
import { usePlayer } from '@src/context/playerContext';
 
export const PlayPauseButton: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
}> = ({playerRef}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const contextPlayerRef = usePlayer();
  const lastStateRef = useRef(false);
  
  const {
    ActiveView: [activeView, setActiveView]
  } = useGlobalContext();

  useEffect(() => {
    const checkPlayingState = () => {
      const currentPlayer = contextPlayerRef.current;
      if (!currentPlayer) return;

      try {
        // console.log('currentPlayer.getCurrentFrame()', currentPlayer.getCurrentFrame());
        const playing = currentPlayer.isPlaying();
        if (playing !== lastStateRef.current) {
          console.log('State changed:', playing);
          lastStateRef.current = playing;
          setIsPlaying(playing);
        }
      } catch (error) {
        console.error('Error checking playing state:', error);
      }
    };

    // Initial check
    checkPlayingState();

    // Check state every 100ms
    const interval = setInterval(checkPlayingState, 100);

    return () => {
      clearInterval(interval);
    };
  }, [contextPlayerRef]);

  const onToggle = useCallback(() => {
    if (activeView === 'canvas') {
      setActiveView('preview');
      return;
    }

    const currentPlayer = contextPlayerRef.current;
    if (!currentPlayer) return;
    
    currentPlayer.toggle();
  }, [contextPlayerRef, activeView, setActiveView]);

  return (
    <Button
      type="text"
      onClick={onToggle}
      icon={isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
    />
  );
};

PlayPauseButton.propTypes = {
  playerRef: PropTypes.exact({
    current: PropTypes.any
  }).isRequired
};
